import { normalizeSearch } from "/app/apps/web/src/routes/_app/search/index.tsx?tsr-shared=1";
import { yearBoundsFromParam } from "@/lib/faceted-search-url";
import { normalizeSearchQuery } from "@/lib/normalize-search-query";
import { prefetchForSsr } from "@/utils/loader";
import { getAlbumSearchQueryOptions, isEmptyAlbumSearch } from "./album-search-query";
import { getArtistSearchQueryOptions } from "./artist-search-query";
import { getCompanySearchQueryOptions } from "./company-search-query";
import { getSearchDiscoveryQueryOptions } from "./search-discovery-query";
interface SearchSearch {
  q?: string;
  genre?: string;
  style?: string;
  type?: AlbumType;
  format?: FormatCategory;
  country?: string;
  origin?: string;
  year?: number[];
  page?: number;
  label?: string[];
  company?: string[];
  forSale?: boolean;
  sort?: string;
  cursor?: string;
}
async function loadSearchRoute(queryClient: QueryClient, rawSearch: Record<string, unknown>, searchStr: string) {
  const search = normalizeSearch(rawSearch);
  const query = search.q || "";
  const page = search.page ?? 1;
  await prefetchMusicSearch(queryClient, search, query, page);
  return {
    searchIndexableRoot: !searchStr
  };
}
async function prefetchMusicSearch(queryClient: QueryClient, search: SearchSearch, query: string, page: number) {
  const labels = search.label ?? [];
  const companies = search.company ?? [];
  const [yearFrom, yearTo] = yearBoundsFromParam(search.year);
  const qTrimmed = normalizeSearchQuery(query);
  const albumInput = {
    query,
    page,
    genre: search.genre,
    style: search.style,
    type: search.type,
    format: search.format,
    country: search.country,
    artistCountry: search.origin,
    yearFrom,
    yearTo,
    labels,
    companies
  };
  const artistInput = {
    query,
    genre: search.genre,
    style: search.style,
    artistCountry: search.origin
  };
  const prefetchDiscovery = isEmptyAlbumSearch(albumInput);
  const albumQueryOptions = getAlbumSearchQueryOptions(albumInput);
  const artistQueryOptions = getArtistSearchQueryOptions(artistInput);
  const companyQueryOptions = qTrimmed.length >= 2 ? getCompanySearchQueryOptions({
    query: qTrimmed
  }) : null;
  const hasArtistBrowseFilter = Boolean(search.genre || search.style);
  const artistEnabled = qTrimmed.length > 0 || hasArtistBrowseFilter;
  const prefetches: Promise<unknown>[] = [];
  if (!prefetchDiscovery) prefetches.push(queryClient.ensureQueryData(albumQueryOptions));
  if (artistEnabled) prefetches.push(queryClient.prefetchQuery(artistQueryOptions));
  if (prefetchDiscovery) {
    prefetches.push(queryClient.prefetchQuery(getSearchDiscoveryQueryOptions()));
  }
  if (companyQueryOptions) prefetches.push(queryClient.prefetchQuery(companyQueryOptions));
  await prefetchForSsr(prefetches);
}
const SplitLoader = async ({
  context: {
    queryClient
  },
  location
}) => loadSearchRoute(queryClient, location.search as Record<string, unknown>, location.searchStr);
export { SplitLoader as loader };